import { render, staticRenderFns } from "./DispatchDocketsShow.vue?vue&type=template&id=2ba9de0a&"
import script from "./DispatchDocketsShow.vue?vue&type=script&lang=js&"
export * from "./DispatchDocketsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports